export default "__VITE_ASSET__BSgLlZDh__"